<template>
  <div class="type">
    <div class="fortyfivefeet" v-if="checkFortyFiveFoot()">
      <p>**45 feet containers cannot be purchased as One Trip</p>
    </div>
    <div id="neworused">
      <label class="grow">
        <input
          type="radio"
          id="NEW"
          value="NEW"
          v-model="bind_Type"
          :disabled="checkFortyFiveFoot()"
        />
        <img :src="img_onetrip" alt="One Trip logo" width="80%" />
      </label>
      <label class="grow">
        <input type="radio" id="USED" value="USED" v-model="bind_Type" />
        <img :src="img_used" alt="Used logo" width="80%" />
      </label>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  name: "NeworUsed",
  mounted() {
    if (this.type === "NEW") {
      this.img_onetrip = this.img_onetrip_selected;
      this.img_used = this.img_used_not_selected;
    } else if (this.type === "USED") {
      this.img_used = this.img_used_selected;
      this.img_onetrip = this.img_onetrip_not_selected;
    } else {
      this.img_onetrip = this.img_onetrip_not_selected;
      this.img_used = this.img_used_not_selected;
    }
  },
  data() {
    return {
      img_onetrip_selected:
        "https://images-wcs.s3-us-west-2.amazonaws.com/One-Trip-Like-New-Checked.png",
      img_onetrip_not_selected:
        "https://images-wcs.s3-us-west-2.amazonaws.com/One-Trip-Like-New-UnChecked.png",
      img_onetrip:
        "https://images-wcs.s3-us-west-2.amazonaws.com/One-Trip-Like-New-Checked.png",
      img_used_selected:
        "https://images-wcs.s3-us-west-2.amazonaws.com/Container-Used-Checked.png",
      img_used_not_selected:
        "https://images-wcs.s3-us-west-2.amazonaws.com/Container-Used-UnChecked.png",
      img_used:
        "https://images-wcs.s3-us-west-2.amazonaws.com/Container-Used-UnChecked.png",
    };
  },
  computed: {
    ...mapGetters({
      type: types.TYPE,
      currentSurveyObject: types.CURRENTSURVEYOBJECT,
    }),
    bind_Type: {
      get() {
        return this.type;
      },
      set(value) {
        this.updateType(value);
      },
    },
  },
  methods: {
    ...mapActions({
      updateType: types.ACTIONS_UPDATE_TYPE,
    }),
    checkFortyFiveFoot() {
      return (
        this.currentSurveyObject &&
        this.currentSurveyObject.description.includes("45")
      );
    },
  },
  watch: {
    //watcher on vuex type and change the image accordingly
    type: function (newValue) {
      if (newValue === "NEW") {
        this.img_onetrip = this.img_onetrip_selected;
        this.img_used = this.img_used_not_selected;
      } else if (newValue === "USED") {
        this.img_used = this.img_used_selected;
        this.img_onetrip = this.img_onetrip_not_selected;
      } else {
        this.img_onetrip = this.img_onetrip_not_selected;
        this.img_used = this.img_used_not_selected;
      }
    },
  },
};
</script>
<style scoped>
input[type="radio"] {
  display: none;
}

input[type="radio"]:checked + img {
  border: 6px solid #6dbe45;
}

[type="radio"] + img {
  cursor: pointer;
  border-radius: 10px;
}

.fortyfivefeet {
  font-size: 20px;
  color: red;
}
</style>
